export const MAP_IMAGE_PULSING_DOT = 'image-pulsing-dot';
export const MAP_SOURCE_PULSING_DOT_POINT = 'source-pulsing-dot-point';
export const MAP_LAYER_PULSING_DOT = 'layer-pursing-dot';
